import script from "./LKUserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./LKUserAvatar.vue?vue&type=script&setup=true&lang=js"

import "./LKUserAvatar.vue?vue&type=style&index=0&id=4c1d9c0e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1d9c0e"]])

export default __exports__